import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLocalizedValue } from '../../../shared/lib/localization';
import { patchClick, deleteTeamClick } from '../lib/teamClick';

const TeamItem = ({ member }) => {
  const navigate = useNavigate();
  const [isDeleted, setIsDeleted] = useState(false);

  if (isDeleted) return null;

  const name = getLocalizedValue(member?.fullName || member?.name, 'ua') || 'Імʼя';
  const role = getLocalizedValue(member?.role, 'ua') || 'Посада';
  const photo = member?.photoUrl || member?.photo || member?.imageURL || '/img/prod-tst.png';
  const isActive = member?.isActive !== false;
  const statusLabel = isActive ? 'Активний' : 'Неактивний';

  const handleDelete = () => {
    deleteTeamClick(member?._id || member?.id, () => {
      setIsDeleted(true);
    });
  };

  return (
    <div className='team-item team-grid'>
      <div className="team-item__info">
        <img src={photo} alt={name} />
        <div className="team-item__info-txt">
          <p className='team_name'>{name}</p>
        </div>
      </div>

      <div className="team-item__info">
        <div className="team-item__info-txt">
          <p className='team_role'>{role}</p>
        </div>
      </div>

      <div className="team-item__info">
        <div className={`team-item__status ${isActive ? 'is-visible' : 'is-hidden'}`}>
          <p>{statusLabel}</p>
        </div>
      </div>

      <div className="team-item__func">
        <button
          type="button"
          className='func-rewrite'
          onClick={() => patchClick(member?._id || member?.id, navigate)}
        >
          Редагувати
        </button>

        <button
          type="button"
          className='func-delete'
          onClick={handleDelete}
        >
          Видалити
        </button>
      </div>
    </div>
  );
};

export default TeamItem;
